<template>
	<FormCategoryAdditionalFee
		:is-submitting="isCreating"
		@onSubmit="handleSubmit"
	/>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FormCategoryAdditionalFee from '@/components/FormCategoryAdditionalFee.vue';
import { priceToAPI } from '../assets/js/helpers';
import { SHIPPING_ADDITIONAL_FEE_TYPE } from '../enums/shippings';

export default {
	name: 'ShippingCategoryAdditionalFeeCreate',

	components: {
		FormCategoryAdditionalFee,
	},
	computed: {
		...mapState('additionalFees', {
			isCreating: (state) => state.additionalFees[SHIPPING_ADDITIONAL_FEE_TYPE.CATEGORY].create.isCreating,
		}),
	},
	methods: {
		...mapActions({
			postAdditionalFee: 'additionalFees/postAdditionalFee',
		}),

		async handleSubmit(fee, categoryIds) {
			const shippingMethodId = this.$route.params.shippingMethodId;
			const params = {
				fee: priceToAPI(fee),
				type: SHIPPING_ADDITIONAL_FEE_TYPE.CATEGORY,
				item_ids: categoryIds,
			};

			try {
				await this.postAdditionalFee({
					id: shippingMethodId,
					type: SHIPPING_ADDITIONAL_FEE_TYPE.CATEGORY,
					params,
				});

				this.$router.push({ name: 'ShippingSetting' });
			} catch {
				// Do nothing
			}
		},
	},
};
</script>
